import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {Input, RadioButton, RadioButtonGroup, FormLayout} from 'components';
/*global $*/

@observer class CoverageCost extends React.Component {
  input;

  componentDidMount() {
    $(this.input).mask('0999999999999999999999.00');
  }

  render() {
    const {enrolment, errorMessage} = this.props;

    return (
      <Input
        label='benefit_enrolment.details.optional_coverage.Cost of coverage (CAD)'
        value={enrolment.cost}
        placeholder='0.00'
        translatePlaceholder={false}
        onChange={e => enrolment.merge({cost: e.target.value})}
        inputRef={input => this.input = input }
        errorMessage={errorMessage}
      />
    );
  }
}

const OptionalCoverageEnrolment = observer(({enrolment, errorMessage}) => {
  return (
    <FormLayout>
      <RadioButtonGroup
        name={enrolment.groupBenefitCoverageId}
        selectedValue={enrolment.enrolled}
        onChange={(name, value) => enrolment.merge({enrolled: value})}
        label={t('benefit_enrolment.details.optional_coverage.DOES_EMPLOYEE_HAVE_OPTIONAL_COVERAGE', {coverageTitle: enrolment.coverageTypeTitle})}
        translateLabel={false}
      >
        <RadioButton className='pr2' value={true}>{t('benefit_enrolment.true')}</RadioButton>
        <RadioButton className='pl2' value={false}>{t('benefit_enrolment.false')}</RadioButton>
      </RadioButtonGroup>
      {enrolment.enrolled && <CoverageCost enrolment={enrolment} errorMessage={errorMessage}/>}
    </FormLayout>
  );
});

export default OptionalCoverageEnrolment;
